import React from 'react';

function Publishers() {
  return <h1>Publishers Page</h1>;
}

export default Publishers;